import React from "react";

import "./Spinner.scss";

const Spinner = () => <span className="spinner" />;

export default Spinner;
